import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-variables-intelligence',
  templateUrl: './select-variables-intelligence.component.html',
  styleUrls: ['./select-variables-intelligence.component.scss']
})
export class SelectVariablesIntelligenceComponent implements  OnDestroy {

  public items: any[] = [
    { value: 'num_stations', variable: 'numStations', name: '# Estaciones' },
    { value: 'market_share', variable: 'marketShare', name: '% Market Share' },
    { value: 'avg_selling_price', variable: 'avgSellingPrice', name: 'Precio Prom' },
    { value: 'avg_margin_tar', variable: 'avgMarginTar', name: 'Marg. TAR Prom' },
    { value: 'quotient', variable: 'quotient', name: 'Indice de Precios' }
  ];

  public variableSelected: any = [];
  public ngxDisabled = true;
  variableSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.variableSelected$ = sharedService.sharedVariableBrand.subscribe((variableSelected: string) => {
      if (this.variableSelected !== variableSelected) {
        this.variableSelected = variableSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    // ngx-select may return the value directly or in an array
    let value = event;
    if (Array.isArray(event) && event.length > 0) {
      value = event[0];
    }
    if (value && typeof value === 'object' && value.value !== undefined) {
      value = value.value;
    }
    
    this.variableSelected = value;
    this.sharedService.nextVariableBrand = this.variableSelected;
  }

  isSelected(option: any): boolean {
    if (!this.variableSelected || 
        (Array.isArray(this.variableSelected) && this.variableSelected.length === 0) ||
        this.variableSelected === '' || 
        this.variableSelected === null ||
        this.variableSelected === undefined) {
      return false;
    }
    
    let selectedValue: any;
    if (Array.isArray(this.variableSelected)) {
      if (this.variableSelected.length === 0) {
        return false;
      }
      selectedValue = this.variableSelected[0];
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    } else {
      selectedValue = this.variableSelected;
      if (selectedValue && typeof selectedValue === 'object' && selectedValue.value !== undefined) {
        selectedValue = selectedValue.value;
      }
    }
    
    return option.value === selectedValue;
  }

}
